var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative order-data"},[_c('div',{staticClass:"refresh-button",on:{"click":function($event){return _vm.$emit('refresh')}}},[_c('i',{staticClass:"fas fa-refresh"}),_vm._v(" "+_vm._s(_vm.$t('cockpit.refresh'))+" ")]),(true)?_c('OrderGeneralTab',{attrs:{"selected":_vm.activeOrder.order}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }